import React from 'react';

// Components
import { Size, Variant, WpButton } from 'Wpds/components/button';
import { WpDivider } from 'Wpds/components/divider';
import { WpLink } from 'Wpds/components/link';
import { WpIcon } from 'Wpds/components/icon';
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';
import { WpText } from 'Wpds/components/text';

// Styles
import './BaseCta.scss';

export interface BaseCtaShowProps {
  showDescription?: boolean;
  showDivider?: boolean;
  buttonSize?: Size;
  illustrationName?: string;
  footerText?: string;
  buttonNote?: string;
  showExternalLink?: boolean;
  buttonVariant?: Variant;
}

interface Props extends BaseCtaShowProps {
  title: string;
  illustration: Illustrations;
  description?: string;
  buttonText: string;
  footerLink?: string;
  className?: string;
  loading?: boolean;
  buttonConfirmationText?: string;
  onButtonClick();
}

const BaseCta = ({
  title,
  illustration,
  description,
  buttonText,
  footerText,
  footerLink,
  loading,
  buttonConfirmationText,
  onButtonClick,
  showDescription = true,
  buttonVariant = 'primary',
  buttonSize = 'md',
  illustrationName,
  buttonNote,
  showDivider = true,
  showExternalLink = true,
}: Props) => {
  const handleButtonClick = () => {
    onButtonClick();
  };

  const baseClassName = 'BaseCta';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__image-wrapper`}>
        <WpIllustration
          src={illustration}
          className={`${baseClassName}__image-wrapper__image  ${baseClassName}__image-wrapper__image__${illustrationName}`}
        />
      </div>
      <h5 className={`${baseClassName}__title`}>{title}</h5>
      {description && showDescription && <p className={`${baseClassName}__text`}>{description}</p>}
      {buttonConfirmationText && (
        <div>
          <WpText variant={'bodySm'} bold={true}>
            {buttonConfirmationText}
          </WpText>
        </div>
      )}
      <div className={`${baseClassName}__button`}>
        <WpButton variant={buttonVariant} size={buttonSize} onClick={handleButtonClick} loading={loading}>
          {buttonText}
        </WpButton>
      </div>
      {buttonNote && (
        <WpText tag="span" variant="bodySm" italic color="gray-500">
          {buttonNote}
        </WpText>
      )}
      {showDivider && <WpDivider padding={16} />}
      {showExternalLink && footerLink && (
        <div className={`${baseClassName}__footer`}>
          <WpLink href={footerLink}>
            <WpIcon name="external-link" />
            {footerText}
          </WpLink>
        </div>
      )}
    </div>
  );
};

export default BaseCta;
